import Routers from './Route';
import AnimationThemeProvider from './_helper/AnimationTheme/AnimationThemeProvider';
import CustomizerProvider from './_helper/Customizer/CustomizerProvider';
import { LoaderProvider } from './_helper/LoaderContext';
import { ClinicProvider } from './_helper/ClinicProvider';
import { PrivilegeContextProvider } from './_helper/PrivilegeContext';
import { NotificationProvider } from './_helper/NotificationContext';
import { BrowserRouter } from 'react-router-dom';
import { SocketProvider } from './_helper/SocketProvider';
import { PharmacyProvider } from './_helper/PharmacyProvider';
import { CurrencyProvider } from './_helper/CurrencyContext';
import { LicenseProvider } from './_helper/license/LicenseContext';
import LicenseCheckWrapper from './_helper/license/LicenseCheckWrapper';
import ScrollToTop from './Components/Common/ScrollToTop';

const App = () => {

  return (
    <div className='App'>
      <PharmacyProvider>
        {/* <LicenseCheckWrapper> */}
        <BrowserRouter basename="/">
          <ScrollToTop />
          <LicenseProvider>
            <CustomizerProvider>
              <AnimationThemeProvider>
                <ClinicProvider>
                  <CurrencyProvider>
                    <PrivilegeContextProvider>
                      <LoaderProvider>
                        <NotificationProvider>
                          {/* <SocketProvider> */}
                          <Routers />
                          {/* </SocketProvider> */}
                        </NotificationProvider>
                      </LoaderProvider>
                    </PrivilegeContextProvider>
                  </CurrencyProvider>
                </ClinicProvider>
              </AnimationThemeProvider>
            </CustomizerProvider>
          </LicenseProvider>
        </BrowserRouter>
        {/* </LicenseCheckWrapper> */}
      </PharmacyProvider>
    </div>
  )
};

export default App;
